var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewreceiveFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.264 2.87a.8.8 0 01.675-.37h6.122a.8.8 0 01.675.37l3.139 4.933a.8.8 0 01.125.43V12.2a.8.8 0 01-.8.8H1.8a.8.8 0 01-.8-.8V8.233a.8.8 0 01.125-.43l3.14-4.933z",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8h3.1a.8.8 0 01.64.32l1.02 1.36a.8.8 0 00.64.32h2.2a.8.8 0 00.64-.32l1.02-1.36A.8.8 0 0111.4 8h3.1",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/newreceive_folder.306d9aac.svg";
export { SvgNewreceiveFolder as ReactComponent };